import { IConnectionConfig, IEdiMessage, Maybe } from 'types/graphqlTypes'
import { formatOptionLabel } from '../EdiSelfServiceOutbound/hooks/useTransactionSets'

export const formattedEdiMessageType = (messageType: IEdiMessage) => {
  return formatOptionLabel({
    transactionSet: messageType.transactionSet,
    transactionSetSubtype: messageType.transactionSetSubtype,
  })
}

export const formatConnectionConfigName = (ediMapperConnectionConfig: Maybe<IConnectionConfig>) => {
  let suffix = ''
  if (ediMapperConnectionConfig?.tmsName) {
    suffix = ` for ${ediMapperConnectionConfig?.tmsName}`
  }
  return `Connection Config ${ediMapperConnectionConfig?.id}${suffix}`
}
